/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-item[_ngcontent-%COMP%]{cursor:pointer;padding:0 25px;font-size:14px}.active[_ngcontent-%COMP%]{color:#50af64}"];
export { styles as styles };
